//initial redux
import { put, call, takeEvery, fork, all, take, takeLatest, select } from "redux-saga/effects";
import { types as sitetreeTypes } from "../SiteTree/redux";
import { TreeFlatener, TreeMap, DateTime, AsyncSaga } from "../../utils";

const initialState = {
	time: {
            startDate: DateTime.startOf("day"),
            endDate: DateTime.endOf("day"),
            key: "selection"
      },
};

/////////
//types
export const types = {
	CHANGE_TIME: "services/Evidence/CHANGE_TIME",
};

///////////
//reducers
export const reducers = {
   reducer(state = initialState, action) {
      switch (action.type) {	
            case types.CHANGE_TIME:
                  return { ...state, isBusy: action.payload.time !== state.time, time: action.payload.time };
            default:
                  return state;
      }
   }
};

//////////
//sagas
export const sagas = {
      *rootSaga() {
            yield all([
                  
            ]);
      },
};

////////
//actions
export const actions = {
      changeTime(time) {
            return {
                  type: types.CHANGE_TIME,
                  payload: { time: time.selection }
            };
      },
      genericAction(type, data) {
            return {
            type,
            payload: data
            };
      }
};



// WEBPACK FOOTER //
// ./src/services/Evidence/redux.js